import { render, staticRenderFns } from "./seePeopleFace.vue?vue&type=template&id=42faa133&scoped=true&"
import script from "./seePeopleFace.vue?vue&type=script&lang=js&"
export * from "./seePeopleFace.vue?vue&type=script&lang=js&"
import style0 from "./seePeopleFace.vue?vue&type=style&index=0&id=42faa133&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42faa133",
  null
  
)

export default component.exports